import { defineQuartzConfig } from 'quartz-core/config';
export default defineQuartzConfig({
  type: 'application',
  auth: 'app',
  historyBasename: '/pricing/:portalId',
  htmlTitle: 'HubSpot Pricing',
  copilotLayoutType: 'sidebar',
  logFetchErrors: {
    options: {
      ignoreErrors: [/failed with status (0|403|404)/, 'Aborting: redirection in progress', 'Error loading the nav script!', 'JSON Syntax Error', 'bindWistiaPlayerEvents', 'InAppNotifications', 'login-verify', /Request aborted/, /Request timeout/, /Loading chunk .* failed./, /Loadable: error loading split chunk/i, /dlb .*bundle.production.js not loaded/i,
      // eslint-disable-next-line hubspot-dev/prefer-hubspot-url-utils
      'Blocked a frame with origin "https://app.hubspot.com" from accessing a cross-origin frame.',
      // eslint-disable-next-line hubspot-dev/prefer-hubspot-url-utils
      'Blocked a frame with origin "https://app-eu1.hubspot.com" from accessing a cross-origin frame.', /Failed to execute '(?:insertBefore|removeChild)' on 'Node'/i, /Identifier 'originalPrompt' has already been declared/, 'Illegal invocation', 'CallingCrossTabClientError', 'Object(...)(...) is undefined', /Permission denied to access property .+ on cross-origin object/, /Cannot read properties of (undefined|null)/, /{"isTrusted": (true|false)}/, /.* RPC failed for .*/, 'failed to initialize chat settings', 'ethereum']
    }
  }
});